export default __webpack_public_path__ + "static/qr-payments-merchant-acquiring-solution-0fd18eeea96cb6dcc9634e9637561f3e.png";